import React from "react";
import ResetPasswordForm from "../auth/components/ResetPasswordForm";

const ResetPasswordPage = () => {
  return <ResetPasswordForm />;
};

export default ResetPasswordPage;
